module.exports = __webpack_public_path__ + "img/platform2.12a5b1f3.png";